/* eslint-disable import/no-unresolved */
import { makeStyles } from 'tss-react/mui';
import Payment from '../../Payment/Payment';

const useStyles = makeStyles()(theme => ({
  main: {
    padding: theme.spacing(2, 2, 0, 2),
    backgroundColor: '#ffffff',
    // overflowY: 'auto',
  },
  inputBox: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  rememberMeBox: {
    marginBottom: theme.spacing(),
  },
  greyBox: {
    flexDirection: 'column',
    backgroundColor: '#F2F2F2',
    padding: theme.spacing(),
    marginBottom: theme.spacing(2),

    '&:last-of-type': {
      marginBottom: 0,
    },
  },
  greyBoxTitle: {
    fontWeight: 500,
    marginBottom: theme.spacing(1 / 2),
  },
  greyBoxAction: {
    marginTop: theme.spacing(),
    width: '100%',
  },
  privacyPolicyLink: {
    alignItems: 'center',
    width: 'auto',
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: theme.spacing(2),
  },
  textarea: {
    width: '100%',
  },
  whiteBoxArea: {
    backgroundColor: '#ffffff',
  },
  checkbox: {
    marginRight: 0,
  },
  cancellationTextBox: {
    flexDirection: 'column',
  },
}));

const CreditCardRequired = (props) => {
  const {
    business: {SalesSetting: salesSettings},
    handleDisplayFlashMessage,
    creditCardHandler,
    cardElementOptions,
    isLoading,
    client,
    title,
    pargraph,
    parentClasses = {},
    buttonText
  } = props;

  const {classes} = useStyles();

  return (
    <div className={parentClasses.paymentWrapper || classes.main}>
      <Payment
        title={title}
        pargraph={pargraph}
        cardElementOptions={cardElementOptions}
        salesSettings={salesSettings}
        handleDisplayFlashMessage={handleDisplayFlashMessage}
        creditCardHandler={creditCardHandler}
        isLoading={isLoading}
        client={client}
        buttonText={buttonText}
        parentClasses={parentClasses}
      />
    </div>
  );
};

export default CreditCardRequired;
